import React from 'react';  
import { Select, MenuItem } from '@material-ui/core';  
import { getWeekStartEnd, generateWeeks, startYear, startWeek } from '../helper/helper'; 

// Dropdown component that lists all the weeks generated by generateWeeks function and allows the user to select a week  
function WeekSelector({ week, handleChangeWeek }) {      
    return (      
        <Select value={week} onChange={handleChangeWeek}>      
            {generateWeeks(startYear, startWeek).map(({week: w, year: y}) => (      
                <MenuItem key={`${y}-${w}`} value={`${y}-${w < 10 ? '0' + w : w}`}>      
                    Year {y}, Week {w < 10 ? '0' + w : w}: {getWeekStartEnd(y, w)}      
                </MenuItem>      
            ))}      
        </Select>      
    );  
}  

export default WeekSelector;